const img = (id, w = 1200) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const PRODUCTS = [
  {
    id: 'eclipse-bomber-98',
    lookupKey: 'aura_eclipse_bomber',
    name: 'Eclipse Bomber 98',
    price: 420,
    category: 'Outerwear',
    zone: 'top',
    color: 'Obsidian',
    tag: 'New Season',
    image: img('photo-1551028719-00167b16eac5'),
    description:
      'A sculpted bomber in coated obsidian nylon. Cropped volume, magnetic closures, and an iridescent Aura lining that shifts under light.',
  },
  {
    id: 'halo-heavyweight-hoodie',
    lookupKey: 'aura_halo_hoodie',
    name: 'Halo Heavyweight Hoodie',
    price: 240,
    category: 'Essentials',
    zone: 'top',
    color: 'Bone White',
    tag: 'Icon',
    image: img('photo-1556821840-3a63f95609a7'),
    description:
      '520gsm loopback fleece with a weightless drape. Tonal halo embroidery at the hood seam. Cut oversized, worn forever.',
  },
  {
    id: 'ghost-layer-tee',
    lookupKey: 'aura_ghost_tee',
    name: 'Ghost Layer Tee',
    price: 120,
    category: 'Essentials',
    zone: 'top',
    color: 'Stark White',
    tag: 'Essential',
    image: img('photo-1521572163474-6864f9cf17ab'),
    description:
      'Our base-layer masterpiece. Supima cotton, ghosted seams, and a fit tuned between slim and relaxed.',
  },
  {
    id: 'liquid-silver-cargo',
    lookupKey: 'aura_liquid_cargo',
    name: 'Liquid Silver Cargo',
    price: 310,
    category: 'Bottoms',
    zone: 'bottom',
    color: 'Muted Silver',
    tag: 'Limited',
    image: img('photo-1594633312681-425c7b97ccd1'),
    description:
      'Fluid technical twill with a liquid-metal sheen. Eight pockets, zero bulk. Falls like mercury.',
  },
  {
    id: 'prism-trench-coat',
    lookupKey: 'aura_prism_trench',
    name: 'Prism Trench Coat',
    price: 680,
    category: 'Outerwear',
    zone: 'top',
    color: 'Holographic Blue',
    tag: 'Statement',
    image: img('photo-1539533018447-63fcce2678e3'),
    description:
      'The house signature. A floor-skimming trench in prism-shift gabardine that refracts lavender to blue as you move.',
  },
  {
    id: 'nebula-knit-sweater',
    lookupKey: 'aura_nebula_knit',
    name: 'Nebula Knit Sweater',
    price: 290,
    category: 'Knitwear',
    zone: 'top',
    color: 'Soft Lavender',
    tag: 'New Season',
    image: img('photo-1576871337622-98d48d1cf531'),
    description:
      'Cloud-spun merino blend with a nebulous marl. Drop shoulders, elongated ribbing, weightless warmth.',
  },
  {
    id: 'orbit-wide-pants',
    lookupKey: 'aura_orbit_pants',
    name: 'Orbit Wide Pants',
    price: 260,
    category: 'Bottoms',
    zone: 'bottom',
    color: 'Deep Obsidian',
    tag: 'Essential',
    image: img('photo-1473966968600-fa801b869a1a'),
    description:
      'A wide orbital leg with a pressed crease and floating waistband. Engineered to move like slow gravity.',
  },
  {
    id: 'signal-utility-vest',
    lookupKey: 'aura_signal_vest',
    name: 'Signal Utility Vest',
    price: 350,
    category: 'Outerwear',
    zone: 'top',
    color: 'Ash Grey',
    tag: 'Limited',
    image: img('photo-1591047139829-d91aecb6caea'),
    description:
      'Modular utility vest in brushed ash nylon. Detachable pouches, hidden comms channel, reflective signal piping.',
  },
];

export const CATEGORIES = ['All', 'Outerwear', 'Essentials', 'Bottoms', 'Knitwear'];

export const EDITORIAL_IMAGES = {
  hero: img('photo-1603189343302-e603f7add05a', 1800),
  arrivalsLead: img('photo-1614873579157-9508b973a9b1', 1600),
  collectionA: img('photo-1715114064382-e0587505fa22', 1600),
  collectionB: img('photo-1632765937900-a3bbbfa58d46', 1600),
  story: img('photo-1445205170230-053b83016050', 1600),
  atelier: img('photo-1558769132-cb1aea458c5e', 1600),
};

export const MANIFESTO = [
  {
    n: '01',
    title: 'Wear it loud',
    body: 'Aura Studio 98 makes clothes for showing up, standing out, and taking the long way home. The uniform changes. The attitude does not.',
  },
  {
    n: '02',
    title: 'Made in small runs',
    body: 'We make fewer pieces and obsess over every one. Strong shapes, lasting fabrics, unexpected details. Nothing is here just to fill a rack.',
  },
  {
    n: '03',
    title: 'Your look, your rules',
    body: 'Mix the polished with the undone. Dress a little too much for the grocery store. The best outfit is the one that feels unmistakably yours.',
  },
];

export const formatPrice = (n, currency = 'USD') =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: n % 1 ? 2 : 0,
  }).format(n);
